import { DEFAULT_ORDER_OPTION } from '@/shared/config';
import type { SortOrder } from '@/shared/lib';

export interface BranchSortOption {
  label: string;
  sort: string;
  order: SortOrder;
}

export const BRANCH_SORT_OPTIONS: BranchSortOption[] = [
  { ...DEFAULT_ORDER_OPTION, label: 'Por mais recente' },
  { label: 'Por mais antigo', sort: 'createdAt', order: 'asc' },
  { label: 'Por ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Por ordem alfabética decrescente', sort: 'name', order: 'desc' },
  { label: 'Do maior número de colaboradores', sort: 'count', order: 'desc' },
  { label: 'Do menor número de colaboradores', sort: 'count', order: 'asc' },
];
